import { PapiGallection } from '@wix/da-papi-types';

export const GalleryOrder = {
  PERSONALIZED: 'personalized',
  NEWEST: 'newest',
} as const;

export type GalleryOrderType = (typeof GalleryOrder)[keyof typeof GalleryOrder];

export interface GallerySettings {
  folderId: number;
  order: GalleryOrderType;
}

export interface GallerySettingsState {
  settings: GallerySettings | null;
  isLoading: boolean;
  error: string | null;
  isSaving: boolean;
  saveError: string | null;
  galleries: PapiGallection[];
}
